import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    t
  } = useLanguage();
  const faqs = [{
    question: t('faq.1.q'),
    answer: t('faq.1.a')
  }, {
    question: t('faq.2.q'),
    answer: t('faq.2.a')
  }, {
    question: t('faq.3.q'),
    answer: t('faq.3.a')
  }, {
    question: t('faq.4.q'),
    answer: t('faq.4.a')
  }, {
    question: t('faq.5.q'),
    answer: t('faq.5.a')
  }, {
    question: t('faq.6.q'),
    answer: t('faq.6.a')
  }];
  return <section className="bg-white py-16 md:py-24" data-id="element-10">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-4" data-id="element-13">
            {t('faq.title')}
          </h2>
          <p className="text-lg text-gray-600" data-id="element-14">{t('faq.subtitle')}</p>
        </motion.div>

        <div className="space-y-4" data-id="element-15">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-16">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex justify-between items-center bg-white hover:bg-gray-50 transition-colors text-left" data-id="element-17">
                <span className="font-semibold text-navy pr-4" data-id="element-18">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-19">
                  <ChevronDown className="text-gold flex-shrink-0" size={20} data-id="element-20" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-21">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-22">
                    <div className="px-6 py-4 bg-lightGray text-gray-700" data-id="element-23">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}